// extracted by mini-css-extract-plugin
export default {"checkboxGroup":"PersonDetails_checkboxGroup","privacyPolicy":"PersonDetails_privacyPolicy","guarantorCheckbox":"PersonDetails_guarantorCheckbox"};